

module.exports = function()
{
    this.staff = null;    
    this.loginViaPin = false;
}